import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import App from './App.tsx';
import './index.scss';
import * as Sentry from '@sentry/react';

const isProd = import.meta.env.MODE === 'production';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error']
    })
  ],
  enabled: isProd
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Произошла непредвиденная ошибка</p>}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
